import axios from 'axios';
import axiosHeader from '_common/runs/axios';

// eslint-disable-next-line import/prefer-default-export
export const getCitiesByState = state => {
  if (state !== '') {
    axios.defaults.headers.common = {};
    return axios
      .get(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${state}/municipios`,
        null
      )
      .then(response => {
        axiosHeader();
        return response.data;
      })
      .catch(err => {
        throw err;
      });
  }
  return false;
};

